export async function fetchWithAuth(url, options = {}) {
    const token = localStorage.getItem("token");
  
    const response = await fetch(url, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
        ...options.headers
      }
    });
  
    // Handle UserLocked globally
    if (response.status === 403) {
      try {
        const errorData = await response.json();
        if (errorData.message === "UserLocked") {
          localStorage.removeItem("token");
          window.location.href = "/login";
          return null;
        }
        return errorData;
      } catch {
        // ignore parse errors
      }
    }
  
    return response.json();
}
  